import React, { useEffect } from 'react';
import PartnersHero from '../components/PartnersHero';
import PartnersList from '../components/PartnersList';
import PartnerRequestForm from '../components/PartnerRequestForm';
import "../styles/Partners.css";

function Partners() {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="partners-page">
      <PartnersHero />
      <PartnersList />
      <PartnerRequestForm />
    </main>
  );
}

export default Partners;
